'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withSlideContext = exports.SlideContext = exports.SlideContextBroadcast = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBroadcast = require('react-broadcast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDE_CHANNEL = 'slideChannel';

var SlideContextBroadcast = function SlideContextBroadcast(_ref) {
    var slide = _ref.slide,
        props = (0, _objectWithoutProperties3.default)(_ref, ['slide']);
    return _react2.default.createElement(_reactBroadcast.Broadcast, (0, _extends3.default)({}, props, { compareValues: _isEqual3.default, channel: SLIDE_CHANNEL, value: slide }));
};
SlideContextBroadcast.propTypes = {
    children: _propTypes2.default.node.isRequired,
    slide: _propTypes2.default.shape({
        isActive: _propTypes2.default.bool.isRequired,
        slideIndex: _propTypes2.default.number.isRequired,
        activeSlideIndex: _propTypes2.default.number.isRequired,
        totalSlides: _propTypes2.default.number.isRequired
    }).isRequired
};

var SlideContext = function SlideContext(props) {
    return _react2.default.createElement(_reactBroadcast.Subscriber, (0, _extends3.default)({}, props, { channel: SLIDE_CHANNEL }));
};
SlideContext.propTypes = {
    children: _propTypes2.default.func.isRequired
};

var withSlideContext = function withSlideContext(Component) {
    var DecoratedComponent = function DecoratedComponent(props) {
        return _react2.default.createElement(
            SlideContext,
            null,
            function (slide) {
                return _react2.default.createElement(Component, (0, _extends3.default)({}, props, { slide: slide }));
            }
        );
    };

    DecoratedComponent.displayName = 'withSlideContext(' + (Component.displayName || Component.name) + ')';
    return DecoratedComponent;
};

exports.SlideContextBroadcast = SlideContextBroadcast;
exports.SlideContext = SlideContext;
exports.withSlideContext = withSlideContext;
//# sourceMappingURL=with-slide-context.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/with-slide-context.js
 ** module id = 289
 ** module chunks = 1
 **/